import React from 'react';
import './Counter.css';
import ElementorButton from './ElementorButton';

interface CounterProps {
    value: number;
    onIncrease: () => void;
    onDecrease: () => void;
    className?: string;
}

const Counter: React.FC<CounterProps> = (props) => {
    const { value, onIncrease, onDecrease, className = '' } = props;

    return (
        <div className={['counter', className].join(' ')}>
            <ElementorButton className="btn-control" onClick={onDecrease}>
                -
            </ElementorButton>
            <span className="text value">{value}</span>
            <ElementorButton className="btn-control" onClick={onIncrease}>
                +
            </ElementorButton>
        </div>
    );
};

export default Counter;
